export default {
  admin: {
    products: {
      holdingData: {
        deleteDataSingleDate: {
          button: "Löschen",
          deleteSuccessText: "Die Portfoliodaten wurden erfolgreich gelöscht.",
          prompt: {
            delete: "Löschen",
            text: (ctx) =>
              `Sie sind dabei, die Portfoliodaten für den ${ctx.named("date")} dauerhaft zu löschen. Wenn Sie sicher sind, klicken Sie unten auf den Button zur Bestätigung.`,
            title: "Portfoliodaten löschen",
          },
        },
        deletePropertyMetadata: {
          deleteSuccessText: "Die Eigenschaft wurde erfolgreich gelöscht.",
          prompt: {
            cancel: "Abbrechen",
            delete: "Löschen",
            deleteForDate: (ctx) => `Für das Datum ${ctx.named("selectedDate")}`,
            deleteGlobally: "Global löschen",
            text: (ctx) =>
              `Sie sind dabei, die Eigenschaft "${ctx.named("propertyToDelete")}" zu löschen. Möchten Sie diese Eigenschaft global oder nur für dieses Datum löschen?`,
            title: "Eigenschaft löschen",
          },
        },
        enrichDataSingleDate: {
          button: "Aus CSV anreichern",
          enrichSuccessText: "Die Portfoliodaten wurden erfolgreich angereichert.",
          emptyCsv: "Keine Daten zum Importieren – die CSV-Datei ist leer.",
          noPropertyToEnrich:
            "Es wurde keine benutzerdefinierte Eigenschaft gefunden, um die aktuellen Daten anzureichern.",
          enrichPrompt: {
            cancel: "Abbrechen",
            condition1:
              "Die Datei muss eine Kopfzeile mit mindestens folgenden Spalten enthalten: 'Holding name', 'Isin', 'Currency' und eine weitere, benutzerdefinierte Eigenschaft.",
            condition2:
              "Jede Zeile muss eine eindeutige Kombination aus 'Holding name', 'Isin' und 'Currency' enthalten.",
            condition3:
              "Jede Kombination aus 'Holding name', 'Isin' und 'Currency' für das Ziel-Datum muss genau einmal in der CSV-Datei vorkommen.",
            enrich: "Anreichern",
            text: "Bitte laden Sie eine CSV-Datei hoch, um die Portfoliodaten anzureichern. Die folgenden Bedingungen müssen erfüllt sein:",
            title: "Portfoliodaten anreichern",
          },
          enrichNewPropertyPrompt: {
            cancel: "Abbrechen",
            enrich: "Anreichern",
            isCategorical: "Kategorisch",
            isCategoricalTooltip:
              "Kategorische Eigenschaften ermöglichen die Gruppierung von Positionen in Bereichen wie 'Übersicht' und 'Factsheet', entweder zu einem bestimmten Datum oder über einen Zeitraum hinweg. Diese Eigenschaften können im Abschnitt 'Holding-Datenanpassung' übersetzt werden. Wenn eine kategorische Eigenschaft automatisch generiert wird (nicht vom Benutzer definiert), kann sie ebenfalls in diesem Abschnitt überschrieben werden.",
            isFfill: "Vorwärts aufgefüllt",
            isFfillTooltip:
              "Wenn für ein ausgewähltes Datum kein Wert verfügbar ist, wird der zuletzt verfügbare vorherige Wert verwendet.",
            newProperty: "Neue Eigenschaft",
            text: "Diese Anreicherung wird neue Eigenschaften erstellen. Bitte prüfen Sie die vorgeschlagenen Eigenschaften und legen Sie deren Standardeinstellungen fest. Hinweis: Selbst kleine Unterschiede in Eigenschaftsnamen (z. B. Groß-/Kleinschreibung) führen zur Erstellung neuer Eigenschaften.",
            title: "Neue Eigenschaften erkannt",
          },
          enrichErrorPrompt: {
            close: "Schließen",
            selectErrorType: "Fehlertyp auswählen:",
            title: "Anreicherungsfehler",
            columns: {
              currency: "Währung",
              firstRow: "Erste Zeile",
              holdingName: "Positionsname",
              isin: "ISIN",
              rowIndex: "Zeilenindex",
            },
            duplicatedHeader: {
              header: "Doppelte Header:",
              title: "Doppelter Header",
              text: "Ihre CSV-Datei enthaelt doppelte Spaltenheader. Bitte benennen Sie diese um, sodass jeder Header eindeutig ist.",
            },
            emptyHeader: {
              title: "Leerer Header",
              text: "Ihre CSV-Datei enthaelt leere Spaltenheader. Bitte vergeben Sie fuer jede Spalte einen Namen mit mindestens einem nicht-leeren Zeichen.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Fehlende Pflichtspalten:",
              title: "Spaltenabweichung",
              text: "Stellen Sie sicher, dass die Kopfzeile der CSV-Datei mindestens folgende Spalten enthält (Groß-/Kleinschreibung beachten): Holding name, Isin, Currency.",
            },
            duplicatedConstituent: {
              title: "Doppelte Position",
              text: "Entfernen Sie doppelte Einträge für dieselbe Position.",
            },
            missingConstituent: {
              title: "Fehlende Position",
              text: "Fügen Sie fehlende Positionen hinzu, damit das CSV das gewählte Datum vollständig abdeckt.",
            },
            papaparseMissingQuotes: {
              title: "Nicht geschlossene Anführungszeichen",
              text: "Die CSV-Analyse ist fehlgeschlagen, weil eine Zeichenkette in Anführungszeichen nicht korrekt geschlossen wurde. Bitte überprüfen Sie Ihre Daten auf fehlende abschließende Anführungszeichen.",
            },
            papaparseUndetectableDelimiter: {
              title: "Nicht erkennbarer Trenner",
              text: "Die CSV-Analyse ist fehlgeschlagen. Es konnte kein gängiger Trenner erkannt werden. Bitte stellen Sie sicher, dass Ihre Datei durchgängig nur einen Trenner verwendet – üblicherweise ein Komma oder ein Semikolon.",
            },
            papaparseTooFewFields: {
              title: "Zu wenige Felder",
              text: "Die CSV-Analyse ist fehlgeschlagen. Jede Zeile sollte die gleiche Anzahl an Spalten wie die Kopfzeile enthalten. Derzeit haben einige Zeilen weniger Spalten als erwartet. Bitte überprüfen Sie die Struktur Ihrer Datei.",
            },
            papaparseTooManyFields: {
              title: "Zu viele Felder",
              text: "Die CSV-Analyse ist fehlgeschlagen. Jede Zeile sollte die gleiche Anzahl an Spalten wie die Kopfzeile enthalten. Derzeit haben einige Zeilen mehr Spalten als erwartet. Bitte überprüfen Sie die Struktur Ihrer Datei.",
            },
          },
        },
        exportDataSingleDate: {
          button: "Als CSV exportieren",
        },
        importDataSingleDate: {
          button: "Aus CSV importieren",
          emptyCsv: "Keine Daten zum Importieren – die CSV-Datei ist leer.",
          importSuccessText: "Die Portfoliodaten wurden erfolgreich importiert.",
          importPrompt: {
            cancel: "Abbrechen",
            condition1:
              "Die Datei muss eine Kopfzeile mit mindestens folgenden Spalten enthalten: 'Holding name', 'Isin', 'Currency', 'value' und 'weight'.",
            condition2:
              "Jede Zeile muss eine eindeutige Kombination aus 'Holding name', 'Isin' und 'Currency' enthalten.",
            condition3:
              "'value' und 'weight' müssen als Zahl im Standardformat angegeben sein (Punkt als Dezimaltrennzeichen, kein Tausendertrennzeichen).",
            date: "Datum",
            import: "Importieren",
            text: "Bitte laden Sie eine CSV-Datei hoch, um Portfoliodaten zu importieren. Die folgenden Bedingungen müssen erfüllt sein:",
            title: "Portfoliodaten importieren",
          },
          importNewPropertyPrompt: {
            cancel: "Abbrechen",
            import: "Importieren",
            isCategorical: "Kategorisch",
            isCategoricalTooltip:
              "Kategorische Eigenschaften ermöglichen die Gruppierung von Positionen in Bereichen wie 'Übersicht' und 'Factsheet', entweder zu einem bestimmten Datum oder über einen Zeitraum hinweg. Diese Eigenschaften können im Abschnitt 'Holding-Datenanpassung' übersetzt werden. Wenn eine kategorische Eigenschaft automatisch generiert wird (nicht vom Benutzer definiert), kann sie ebenfalls in diesem Abschnitt überschrieben werden.",
            isFfill: "Vorwärts aufgefüllt",
            isFfillTooltip:
              "Wenn für ein ausgewähltes Datum kein Wert verfügbar ist, wird der zuletzt verfügbare vorherige Wert verwendet.",
            newProperty: "Neue Eigenschaft",
            text: "Diese Importaktion wird neue Eigenschaften erstellen. Bitte prüfen Sie die vorgeschlagenen Eigenschaften und legen Sie deren Standardeinstellungen fest. Hinweis: Selbst kleine Unterschiede in Eigenschaftsnamen (z. B. Groß-/Kleinschreibung) führen zur Erstellung neuer Eigenschaften.",
            title: "Neue Eigenschaften erkannt",
          },
          importErrorsPrompt: {
            close: "Schließen",
            selectErrorType: "Fehlertyp auswählen:",
            title: "Importfehler",
            columns: {
              currency: "Währung",
              firstRow: "Erste Zeile",
              holdingName: "Positionsname",
              isin: "ISIN",
              rowIndex: "Zeilenindex",
            },
            duplicatedHeader: {
              header: "Doppelte Header:",
              title: "Doppelter Header",
              text: "Ihre CSV-Datei enthaelt doppelte Spaltenheader. Bitte benennen Sie diese um, sodass jeder Header eindeutig ist.",
            },
            emptyHeader: {
              title: "Leerer Header",
              text: "Ihre CSV-Datei enthaelt leere Spaltenheader. Bitte vergeben Sie fuer jede Spalte einen Namen mit mindestens einem nicht-leeren Zeichen.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Fehlende Pflichtspalten:",
              title: "Spaltenabweichung",
              text: "Stellen Sie sicher, dass die Kopfzeile mindestens folgende Spalten enthält (Groß-/Kleinschreibung beachten): Holding name, Isin, Currency, value, weight.",
            },
            duplicatedConstituent: {
              title: "Doppelte Position",
              text: "Entfernen Sie doppelte Einträge für dieselbe Position.",
            },
            missingValue: {
              title: "Fehlender Wert",
              text: "Einige Zeilen enthalten keinen Wert. Stellen Sie sicher, dass jede Zeile einen korrekt formatierten numerischen Wert enthält.",
            },
            invalidValueFormat: {
              title: "Ungültiges Wertformat",
              text: "Das Format der Spalte 'value' konnte nicht erkannt werden. Verwenden Sie einen Punkt als Dezimaltrennzeichen und keinen Tausendertrennzeichen.",
            },
            missingWeight: {
              title: "Fehlendes Gewicht",
              text: "Einige Zeilen enthalten kein Gewicht. Stellen Sie sicher, dass jede Zeile ein korrekt formatiertes numerisches Gewicht enthält.",
            },
            invalidWeightFormat: {
              title: "Ungültiges Gewichtformat",
              text: "Das Format der Spalte 'weight' konnte nicht erkannt werden. Verwenden Sie einen Punkt als Dezimaltrennzeichen und keinen Tausendertrennzeichen.",
            },
            papaparseMissingQuotes: {
              title: "Nicht geschlossene Anführungszeichen",
              text: "Die CSV-Analyse ist fehlgeschlagen, weil eine Zeichenkette in Anführungszeichen nicht korrekt geschlossen wurde. Bitte überprüfen Sie Ihre Daten auf fehlende abschließende Anführungszeichen.",
            },
            papaparseUndetectableDelimiter: {
              title: "Nicht erkennbarer Trenner",
              text: "Die CSV-Analyse ist fehlgeschlagen. Es konnte kein gängiger Trenner erkannt werden. Bitte stellen Sie sicher, dass Ihre Datei durchgängig nur einen Trenner verwendet – üblicherweise ein Komma oder ein Semikolon.",
            },
            papaparseTooFewFields: {
              title: "Zu wenige Felder",
              text: "Die CSV-Analyse ist fehlgeschlagen. Jede Zeile sollte die gleiche Anzahl an Spalten wie die Kopfzeile enthalten. Derzeit haben einige Zeilen weniger Spalten als erwartet. Bitte überprüfen Sie die Struktur Ihrer Datei.",
            },
            papaparseTooManyFields: {
              title: "Zu viele Felder",
              text: "Die CSV-Analyse ist fehlgeschlagen. Jede Zeile sollte die gleiche Anzahl an Spalten wie die Kopfzeile enthalten. Derzeit haben einige Zeilen mehr Spalten als erwartet. Bitte überprüfen Sie die Struktur Ihrer Datei.",
            },
          },
        },
        updatePropertyMetadata: {
          saveSuccessText: "Die Eigenschaft wurde erfolgreich aktualisiert.",
          unsavedChangesAlert:
            "Sie haben ungespeicherte Änderungen. Wenn Sie jetzt verlassen, gehen diese verloren.",
          prompt: {
            isCategorical: "Kategorisch",
            isCategoricalTooltip:
              "Kategorische Eigenschaften ermöglichen die Gruppierung von Positionen in Bereichen wie 'Übersicht' und 'Factsheet', entweder zu einem bestimmten Datum oder über einen Zeitraum hinweg. Diese Eigenschaften können im Abschnitt 'Holding-Datenanpassung' übersetzt werden. Wenn eine kategorische Eigenschaft automatisch generiert wird (nicht vom Benutzer definiert), kann sie ebenfalls in diesem Abschnitt überschrieben werden.",
            isFfill: "Vorwärts aufgefüllt",
            isFfillTooltip:
              "Wenn für ein ausgewähltes Datum kein Wert verfügbar ist, wird der zuletzt verfügbare vorherige Wert verwendet.",
            propertyForUrl: "URL-Eigenschaft",
            propertyForUrlTooltip:
              "Geben Sie den Namen der Eigenschaft an, die die URL enthält. Der Wert der aktuellen Eigenschaft wird als klickbarer Text verwendet.",
            title: "Eigenschaft bearbeiten",
            translation: "Übersetzung",
          },
        },
      },
    },
  },
  auth: {
    resetPasswordLink: {
      forgotPassword: "Passwort vergessen?",
    },
  },
  cards: {
    needLoginCard: {
      needLogged: "Um diesen Inhalt zu sehen, müssen Sie angemeldet sein.",
    },
  },
  compliance: {
    cookies: {
      buttonText: "Akzeptieren",
      cookiesUsage:
        "Diese Website verwendet Cookies, um die Benutzerfreundlichkeit zu verbessern. Durch die Nutzung dieser Website erklären Sie sich mit der Verwendung von Cookies sowie mit der Datenschutzerklärung einverstanden, in der Sie weitere Informationen über Cookies finden. Link: {0}.",
      privacyPolicy: "Datenschutzerklärung",
    },
  },
  components: {
    biggestDrawdownsTable: {
      rank: "Rang",
      startDate: "Startdatum",
      troughDate: "Tiefpunkt",
      recoveryDate: "Erholungsdatum",
    },
    stressTestScenariosTable: {
      scenario: "Szenario",
      period: "Periode",
      scenarioExtremelyBad: "Extrem ungünstig",
      scenarioUnfavourable: "Ungünstig",
      scenarioModerate: "Moderat",
      scenarioFavourable: "Günstig",
    },
    liquidityRiskScenarioTable: {
      timeToLiquidate: "Zeit bis zur Liquidierung",
      timeBucket1Day: "0-1 Tag",
      timeBucket2To7Days: "2-7 Tage",
      timeBucket8To30Days: "8-30 Tage",
      timeBucket31To90Days: "31-90 Tage",
      timeBucket91To180Days: "91-180 Tage",
      timeBucket181To365Days: "181-365 Tage",
      timeBucketMoreThan365Days: ">365 Tage",
      waterfallCumulativeWeight: "Waterfall kumulatives Gewicht",
      proRataCumulativeWeight: "Pro-Rata kumulatives Gewicht",
      nearProportionalCumulativeWeight: "Nahezu proportional kumulatives Gewicht",
    },
    details: {
      report: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} Million${ctx.named("aum") > 1000000 ? "en" : ""}${
            ctx.named("asOfDate") ? ` (Stand ${ctx.named("asOfDate")})` : ""
          }`,
        lastPrice: (ctx) => `${ctx.named("currency")} ${ctx.named("lastPrice")}`,
      },
      overview: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} Million${ctx.named("aum") > 1000000 ? "en" : ""} (Stand ${ctx.named("asOfDate")})`,
        lastPrice: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("lastPrice")} (Stand ${ctx.named("asOfDate")})`,
      },
    },
    returnsVarGraph: {
      dailyReturn: "Tägliche Rendite",
      twoWeekReturn: "2-Wochen-Rendite",
      monthlyReturn: "Monatsrendite",
      oneDayOnePercent: "1-Tag-VaR (99%)",
      oneDayFivePercent: "1-Tag-VaR (95%)",
      twoWeeksOnePercent: "2-Wochen-VaR (99%)",
      twoWeeksFivePercent: "2-Wochen-VaR (95%)",
      oneMonthOnePercent: "1-Monats-VaR (99%)",
      oneMonthFivePercent: "1-Monats-VaR (95%)",
    },
    download: {
      tooltip: "Als Bild herunterladen",
      prompt: {
        downloadPngButton: "Als PNG herunterladen",
        downloadSvgButton: "Als SVG herunterladen",
        text: "Wählen Sie das Format, in dem Sie die Komponente herunterladen möchten.",
        title: "Komponente herunterladen",
      },
    },
    portfolioBreakdownOnDate: {
      noDataYet: "Diese Komponente enthält noch keine Daten.",
    },
    portfolioBreakdownOverTime: {
      noDataYet: "Diese Komponente hat noch nicht genügend Daten.",
    },
    statisticsWithPeriods: {
      noStatisticsToDisplay: "Keine Statistiken zum Anzeigen.",
    },
    statistics: {
      noStatisticsToDisplay: "Keine Statistiken zum Anzeigen.",
    },
    operations: {
      statuses: {
        failed: "Fehlgeschlagen",
        pending: "Ausstehend",
        running: "Läuft",
        succeeded: "Erfolgreich",
      },
    },
  },
  datePickers: {
    datePicker: {
      selectDateTooltip: "Datum auswählen",
    },
    dateRangePicker: {
      from: "Von (JJJJ-MM-TT)",
      fullPeriod: "Gesamter Zeitraum",
      to: "Bis (JJJJ-MM-TT)",
    },
    zoomPicker: {
      fiveYears: "5J",
      fullPeriod: "MAX",
      oneMonth: "1M",
      oneYear: "1J",
      sevenYears: "7J",
      sixMonths: "6M",
      threeMonths: "3M",
      tenYears: "10J",
      threeYears: "3J",
      twoYears: "2J",
      ytd: "YTD",
    },
  },
  dropdowns: {
    iconsDropdown: {
      noIcon: "Kein Symbol",
    },
  },
  editPrompt: {
    copyInAllLangs: "Kopieren in allen Sprachen",
    editField: "Feld bearbeiten",
    enterText: "Text eingeben",
    overwriteDataAllShareClasses: "Daten aller Anteilsklassen überschreiben",
    propertyFilters: {
      title: "Eigenschaftsfilter",
      tooltip:
        "Damit eine Position berücksichtigt wird, muss sie alle angewendeten Filter erfüllen. Eine Position erfüllt einen Filter, wenn sie einem der ausgewählten Werte entspricht.",
      property: "Eigenschaft",
      values: "Werte",
      empty: "Noch kein Eigenschaftsfilter.",
      add: "Eigenschaftsfilter hinzufügen",
      multiSelect: {
        placeholder: "Werte auswählen",
        selectLabel: "Enter drücken zum Auswählen",
        deselectLabel: "Enter drücken, um zu entfernen",
        selectedLabel: "Ausgewählt",
        limitText: (ctx) => `und ${ctx.named("count")} weitere`,
      },
    },
    id: "ID",
    idTooltip:
      "Dieser eindeutige Bezeichner dient als Referenz für die Komponente innerhalb der Plattform. Jede Komponente, die Sie erstellen, benötigt einen eigenen Bezeichner. Zur besseren Lesbarkeit empfehlen wir die folgende Konvention: Verwenden Sie den Komponententitel, konvertieren Sie ihn in Kleinbuchstaben und ersetzen Sie Leerzeichen durch Bindestriche. Für eine Komponente mit dem Titel 'My Analytic Table' würde der Bezeichner 'my-analytic-table' lauten.",
    needUniqueId:
      "Der angegebene Bezeichner wird derzeit von einer anderen Komponente am aktuellen Standort oder an einem verknüpften Standort verwendet. Bitte geben Sie einen eindeutigen Bezeichner an, um die Eindeutigkeit zu gewährleisten.",
    numberOfDecimals: "Anzahl der Nachkommastellen",
    numberOfDecimalsTooltip:
      "Die Anzahl der Nachkommastellen für alle in der Komponente angezeigten Zahlen. Beachten Sie, dass dies nicht für Diagrammachsen gilt.",
    withBenchmark: "Mit dem Benchmark anzeigen",
    resamplingStrategy: "Resampling-Strategie",
    windowHorizon: "Gleitender Zeitraum",
    windowHorizonTooltip:
      "Der Gleitende Zeitraum bestimmt den 'Look-Back' Zeitraum, der für die Berechnung der jährlichen Volatilität bei jedem Punkt auf dem Diagramm verwendet wird. Ein kürzerer Zeitraum (z.B. 3 Monate) macht das Diagramm sehr reaktiv auf kurzfristige Marktstöße und plötzliche Regime-Schichtungen, obwohl es aufgrund temporärer Schwankungen laut möglicherweise 'lärmig' erscheinen kann. Im Gegensatz dazu bietet ein längerer Zeitraum (z.B. 1 Jahr) eine glattere, stabilere Ansicht der langfristigen Risiken, indem kurzfristige Marktnoisefilterung entfernt wird, obwohl es sich langsamer auf aktuelle Ereignisse reagiert. Beachten Sie, dass das Wählen eines längeren Zeitraums auch dazu führt, dass das Diagramm später beginnt, da die Berechnung eine vollständige historische Periode vor dem ersten Wert benötigt, um ihn zu plotten.",
    windowHorizonOptions: {
      threeMonths: "3 Monate",
      sixMonths: "6 Monate",
      oneYear: "1 Jahr",
      twoYears: "2 Jahre",
      threeYears: "3 Jahre",
      fiveYears: "5 Jahre",
      sevenYears: "7 Jahre",
      tenYears: "10 Jahre",
    },
    timeWindow: "Zeitfenster",
    timeWindowOptions: {
      threeMonths: "3 Monate",
      sixMonths: "6 Monate",
      oneYear: "1 Jahr",
      twoYears: "2 Jahre",
      threeYears: "3 Jahre",
      fourYears: "4 Jahre",
      fiveYears: "5 Jahre",
      sixYears: "6 Jahre",
      sevenYears: "7 Jahre",
      eightYears: "8 Jahre",
      nineYears: "9 Jahre",
      tenYears: "10 Jahre",
      all: "Alle",
    },
    valueAtRisk: "Value at Risk",
    valueAtRiskOptions: {
      oneDayOnePercent: "1-Tag-VaR (99%)",
      oneDayFivePercent: "1-Tag-VaR (95%)",
      twoWeeksOnePercent: "2-Wochen-VaR (99%)",
      twoWeeksFivePercent: "2-Wochen-VaR (95%)",
      oneMonthOnePercent: "1-Monats-VaR (99%)",
      oneMonthFivePercent: "1-Monats-VaR (95%)",
    },
    footnote: "Text unter der Komponente",
    placeholderFootnote:
      "Ein Text, der unterhalb der Komponente erscheint. Z. B. 'Gebühren sind inbegriffen.'",
    langTabError: "Einige Felder sind in den folgenden Sprachen ungültig:",
    settingsOnlyUsedOnOverviewTooltip:
      "Diese Einstellung betrifft ausschließlich die Ansicht 'Übersicht'.",
    startDate: "Anfangsdatum",
    startDateTooltip:
      "Wählen Sie ein Anfangsdatum (im Format JJJJ-MM-TT) für die Komponente. Die Komponente wird automatisch so angepasst, dass die Daten ab dem frühesten verfügbaren Datum für das Produkt oder dem von Ihnen gewählten Datum angezeigt werden, je nachdem, welches Datum später liegt. Wenn Sie dieses Feld leer lassen, werden alle verfügbaren Preisdaten für das Produkt angezeigt.",
    tabError: "Einige Felder sind ungültig",
    title: "Titel",
    titleEdit: (ctx) => `${ctx.named("componentId")} bearbeiten`,
    titleAdd: "Komponente hinzufügen",
    unsavedChangesAlert:
      "Sie haben ungespeicherte Änderungen. Wenn Sie nicht speichern, gehen sie verloren.",
    resamplingStrategyOptions: {
      standard: "Standard",
      standardTooltip:
        "Passt den Detaillierungsgrad automatisch an den gewählten Zeitraum an, um das Diagramm übersichtlich und lesbar zu halten.",
      monthly: "Monatlich",
      monthlyTooltip:
        "Zeigt den zuletzt erfassten Wert für jeden Monat im ausgewählten Zeitraum an.",
    },
    reportFooter: {
      title: "Fußzeile",
      text: "Text",
      saveSuccess: "Fußzeile wurde erfolgreich aktualisiert",
      showPageNumber: "Seitenzahl anzeigen",
      showFooterLine: "Fußzeile anzeigen",
      margins: {
        bottom: "Unten",
        left: "Links",
        right: "Rechts",
        title: "Margen (mm)",
      },
    },
    reportHeader: {
      backgroundImage: "Hintergrundbild",
      backgroundImageTooltip:
        "Die Abmessungen der Kopfzeile betragen 794 Pixel in der Breite und die für die Höhe gewählte Höhe (siehe unten). Verwenden Sie daher ein Bild mit den gleichen Abmessungen, um ein optimales Ergebnis zu erzielen.",
      logo: "Logo",
      text: "Text",
      saveSuccess: "Kopfzeile wurde erfolgreich aktualisiert",
      showDateRange: "Datumsbereich anzeigen",
      textInPrimary: "Text in Markenfarbe",
      title: "Header",
      useCompanyLogo: "Firmenlogo verwenden",
      logoPosition: {
        left: "Links",
        right: "Rechts",
        title: "Logoposition",
      },
      datePosition: {
        bottomLeft: "Unten links",
        bottomRight: "Unten rechts",
        centerLeft: "Mitte links",
        centerRight: "Mitte rechts",
        hidden: "Ausgeblendet",
        title: "Datumsposition",
        topLeft: "Oben links",
        topRight: "Oben rechts",
      },
      headerVisibility: {
        allPages: "Alle Seiten",
        hidden: "Ausgeblendet",
        onlyFirstPage: "Nur auf der ersten Seite",
        title: "Sichtbarkeit der Kopfzeile",
      },
      height: {
        title: "Höhe",
        large: "Groß (200 px / ~52,90 mm)",
        normal: "Normal (150 px / ~39,67 mm)",
        small: "Klein (100 px / ~26,45 mm)",
        veryLarge: "Sehr groß (250 px / ~66,12 mm)",
      },
      margins: {
        bottom: "Unten",
        left: "Links",
        right: "Rechts",
        top: "Oben",
        title: "Margen (mm)",
        tooltip: "Die Ränder haben keinen Einfluss auf das Hintergrundbild.",
      },
      productNamePosition: {
        bottomLeft: "Unten links",
        bottomRight: "Unten rechts",
        centerLeft: "Mitte links",
        centerRight: "Mitte rechts",
        hidden: "Ausgeblendet",
        title: "Position des Produktnamens",
        topLeft: "Oben links",
        topRight: "Oben rechts",
      },
      textPosition: {
        bottomLeft: "Unten links",
        bottomRight: "Unten rechts",
        centerLeft: "Mitte links",
        centerRight: "Mitte rechts",
        title: "Textsposition",
        topLeft: "Oben links",
        topRight: "Oben rechts",
      },
    },
    reportStyle: {
      primaryColor: "Hauptfarbe",
      colorSchemePicker: "Farbschema-Auswahl",
      colorSchemeTooltip:
        "Dieses Farbschema wird derzeit auf Kreis- und Donutdiagramme angewendet. Wenn keine Farben angegeben werden, verwenden die Diagramme standardmäßig das allgemeine Farbschema der Plattform.",
      saveSuccess: "Stil wurde erfolgreich aktualisiert",
      title: "Stil",
      fontSize: {
        normal: "Normal",
        large: "Gross",
        small: "Klein",
        title: "Schriftgrösse",
      },
      margins: {
        left: "Links",
        right: "Rechts",
        title: "Margen (mm)",
      },
      spacing: {
        comfortable: "Bequem",
        compact: "Kompakt",
        title: "Abstände",
      },
      titleBorder: {
        above: "Oberhalb dem Titel",
        below: "Unter dem Titel",
        none: "Keine Grenze",
        title: "Titel Grenze",
      },
      titlesBold: {
        title: "Komponententitel fett",
      },
    },
    genericComponent: {
      addColumn: "Spalte hinzufügen",
      addRow: "Reihe hinzufügen",
      addData: "Daten hinzufügen",
      cantChangeType:
        "Sie können den Typ einer generische Komponente nicht ändern, nachdem Sie sie gespeichert haben. Wenn Sie einen anderen Typ möchten, müssen Sie eine neue generische Komponente erstellen.",
      columnWithIndex: (ctx) => `Spalte ${ctx.named("idx")}`,
      data: "Daten",
      date: "Datum",
      displayValuesAsPerc: "Zeigt Werte als Prozentsatz an",
      displayValuesAsPercTooltip: "Zeigt Werte mit einem '%'-Symbol im Diagramm an.",
      donutChart: "Donutdiagramm",
      exampleSector: "Z.B., Sektoren",
      header: "Kopfzeile",
      horizontalBarChart: "Horizontales Balkendiagramm",
      key: "Schlüssel",
      image: "Bild",
      lineChart: "Liniendiagramm",
      needData:
        "Sie können eine generische Komponente nicht ohne Daten oder nur mit teilweisen Daten speichern. Löschen Sie sie, fügen Sie Daten hinzu oder vervollständigen Sie vorhandene Daten vor dem Speichern.",
      pieChart: "Kreisdiagramm",
      removeData: "Daten entfernen",
      showColumnHeader: "Spaltenüberschrift anzeigen",
      table: "Tabelle",
      text: "Text",
      type: "Typ",
      value: "Wert",
      verticalBarChart: "Vertikales Balkendiagramm",
      video: "Video",
      weightPercent: "Gewicht (in %)",
      lineChartSection: {
        fileMust: "Ihre Datei muss:",
        selectFile: "Datei auswählen",
        uploadCsv: "Laden Sie eine CSV-Datei mit Ihren Zeitreihendaten hoch.",
        conditions: {
          dateFormat: "Das Datumsformat <strong>YYYY-MM-DD</strong> verwenden.",
          dateIncreaseAndUnique: "Strikt zunehmende und eindeutige Daten enthalten.",
          headerRow:
            "Eine Kopfzeile mit den Spalten <code>date</code> und <code>value</code> enthalten.",
          maxPoints:
            "Maximal <strong>500 Zeilen</strong> und eine Dateigröße unter <strong>1&nbsp;MB</strong> haben.",
          numberFormat:
            "Verwenden Sie einen Punkt (.) als Dezimaltrennzeichen und fügen Sie keine Tausendertrennzeichen ein.",
        },
        errors: {
          exceedSize: {
            title: "Datei zu groß",
            text: "Die hochgeladene Datei überschreitet 1&nbsp;MB. Bitte beschränken Sie sie auf maximal 500 Datenpunkte.",
          },
          invalidData: {
            title: "Ungültige Daten erkannt",
            text: "Einige Zeilen enthalten fehlende oder ungültige Werte. Stellen Sie sicher, dass die Spalte <code>date</code> das Format <strong>YYYY-MM-DD</strong> verwendet und die Spalte <code>value</code> gültige Zahlen enthält.",
          },
          invalidDataSequence: {
            title: "Ungültige Datumsreihenfolge",
            text: "Die Daten müssen strikt zunehmend und eindeutig sein. Bitte korrigieren Sie Ihre Datei und versuchen Sie es erneut.",
          },
          parseFail: {
            title: "Analyse fehlgeschlagen",
            text: "Die CSV-Datei konnte nicht korrekt gelesen werden. Überprüfen Sie das Format und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie das Alquant-Team.",
          },
          tooManyDataPoints: {
            title: "Zu viele Datenpunkte",
            text: "Ihre Datei enthält mehr als 500 Zeilen. Bitte reduzieren Sie sie auf höchstens 500, bevor Sie sie hochladen.",
          },
          unexpectedError: {
            title: "Unerwarteter Fehler",
            text: "Beim Verarbeiten Ihrer Datei ist ein unerwarteter Fehler aufgetreten. Bitte kontaktieren Sie das Alquant-Team.",
          },
        },
      },
    },
    contacts: {
      addContact: "Kontakt hinzufügen",
      contacts: "Kontakte",
      contactsPerRow: "Kontakte pro Zeile",
      additionalText: "Zusätzlicher Text",
      email: "E-Mail",
      exampleEmail: "Z.B., jdoe@mail.com",
      exampleName: "Z.B., John Doe",
      examplePhone: "Z.B., +41 79 123 45 67",
      exampleRole: "Z.B., Partner",
      image: "Bild",
      name: "Name",
      phone: "Telefon",
      removeContact: "Kontakt entfernen",
      role: "Rolle",
    },
    dialog: {
      copyInAllLangs: {
        title: "Kopieren in allen Sprachen",
        text: "Sie kopieren alle Werte der aktuellen Sprache in alle anderen Sprachen. Sind Sie sicher?",
      },
      saveFieldInAllShareClasses: {
        title: "Überschreiben",
        text: "Sie überschreiben dieses Feld in allen anderen Anteilsklassen dieses Produkts, nicht nur in der aktuellen Anteilsklasse. Sind Sie sicher?",
      },
      saveInAllShareClasses: {
        title: "Überschreiben",
        text: (ctx) =>
          `Sie überschreiben die Daten von "${ctx.named(
            "tabName"
          )}" in allen anderen Anteilsklassen dieses Produkts mit den Daten von "${ctx.named(
            "tabName"
          )}" dieser Anteilsklasse (nicht nur die letzten Änderungen, die Sie vorgenommen haben). Sind Sie sicher?`,
      },
    },
    description: {
      contentTitle: "Beschreibung",
    },
    disclaimer: {
      contentTitle: "Haftungsausschluss",
      defaultWarning:
        "Sie haben derzeit keinen Haftungsausschluss für dieses Produkt. Daher wurde der Standard-Haftungsausschluss verwendet. Wenn Sie hier einen Haftungsausschluss verfassen, wird dieser nur für dieses Produkt angezeigt und nicht der Standard-Haftungsausschluss.",
    },
    historicalPricesChart: {
      adjusted: "Bereinigte Preise verwenden",
      adjustedTooltip:
        "Unter bereinigten Preisen versteht man im Allgemeinen Preise, die um Dividenden, Splits und andere Ereignisse bereinigt sind. Der nicht bereinigte Preis bezieht sich einfach auf die Kosten für eine Aktie des Produkts am Ende des Tages.",
      defaultLogScale: "Standardmäßig in LogScale",
      showLogScaleSwitch: "Schalter für LogScale anzeigen",
      priceIndexedTo100: "Preise indexiert auf 100 verwenden",
    },
    portfolioBreakdown: {
      cantChangeProperty:
        "Sie können die Eigenschaft einer Holding-Komponente nicht ändern, nachdem Sie sie gespeichert haben. Wenn Sie eine andere Eigenschaft wünschen, müssen Sie eine neue Holding-Komponente erstellen.",
      chartType: "Diagrammtyp",
      displayOrder: "Anzeigereihenfolge",
      donutChart: "Donutdiagramm",
      horizontalBarChart: "Horizontales Balkendiagramm",
      lagRule: "Verzögerungsregel für Daten",
      lagRuleTooltip:
        "Wählen Sie, um wie viel die in dieser Komponente angezeigten Daten verzögert werden sollen. Eine Zwei-Monats-Ende-Verzögerung bedeutet zum Beispiel, dass die neuesten verfügbaren Daten vom Monatsende vor zwei Monaten angezeigt werden. Wenn heute der 15. Januar 2025 ist, werden die Daten bis zum 30. November 2024 angezeigt.",
      pieChart: "Kreisdiagramm",
      property: "Eigenschaft",
      table: "Tabelle",
      verticalBarChart: "Vertikales Balkendiagramm",
      onlyShowTopThenOthers: {
        title: "Nur Top anzeigen",
        tooltip:
          'Nur das oberste X (gewählte Zahl) anzeigen, und die übrigen in "Andere" zusammenfassen. Leer lassen, um alle anzuzeigen.',
      },
      categoryIdsInOthers: {
        title: 'Elemente, die als "Andere" zu betrachten sind',
        multiSelect: {
          placeholder: "Elemente auswählen",
          selectLabel: "Enter drücken zum Auswählen",
          deselectLabel: "Enter drücken, um zu entfernen",
          selectedLabel: "Ausgewählt",
          limitText: (ctx) => `und ${ctx.named("count")} weitere`,
        },
      },
      sortOptions: {
        alphabeticallyAscending: "Name (A → Z)",
        alphabeticallyDescending: "Name (Z → A)",
        weightAscending: "Gewicht (niedrig → hoch)",
        weightDescending: "Gewicht (hoch → niedrig)",
      },
      lagRuleOptions: {
        noLag: "Keine Verzögerung (aktuellste Daten)",
        oneMonthEnd: "Monatsende des Vormonats",
        twoMonthEnd: "Monatsende vor zwei Monaten",
      },
      normalizeBreakdownWeight: "Gewichte normalisieren",
      normalizeBreakdownWeightTooltip:
        "Wenn aktiviert, werden die Gewichte so skaliert, dass sie sich an dem gewählten Stichtag auf alle Kategorien zu 100 % summieren (oder auf jeden Zeitpunkt der Zeitreihe).",
    },
    keyCharacteristics: {
      addKeyCharacteristics: "Schlüsselmerkmale hinzufügen",
      exampleDynamicExposure: "z. B., Dynamische Exposition",
      exampleWeDynamicallyAdapt: "z. B., Wir passen uns dynamisch an ...",
      header: "Überschrift",
      icon: "Symbol",
      paragraph: "Absatz",
      removeKeyCharacteristics: "Hauptmerkmale entfernen",
    },
    biggestDrawdownsTable: {
      numberOfDrawdowns: "Anzahl der Drawdowns",
    },
    stressTestScenariosTable: {
      product: "Produkt",
      benchmark: "Benchmark",
      periods: "Perioden",
      addPeriod: "Periode hinzufügen",
      deletePeriod: "Periode löschen",
    },
    liquidityAnalysisTable: {
      customizedTable: "Vorschautabelle",
      holdingsToIgnore: {
        title: "Zu ignorierende Positionen",
        holdingsMultiselect: {
          placeholder: "Zu ignorierende Positionen auswählen",
          selectLabel: "Enter drücken zum Auswählen",
          deselectLabel: "Enter drücken, um zu entfernen",
          selectedLabel: "Ausgewählt",
          limitText: (ctx) => `und ${ctx.named("count")} weitere`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Holdings ignorieren, deren Name enthält",
        placeholder: "z. B. Bargeld, Sonstiges",
      },
    },
    liquidityRiskScenarioTable: {
      rowsByTimeBucket: "Daten nach Zeit bis zur Liquidierung",
      amountPlaceholder: "Betrag (Mio)",
      weightPlaceholder: "Gewicht (%)",
    },
    monthlyReturnsTable: {
      descending: "Jahre in absteigender Reihenfolge sortieren",
      benchmark: "Benchmark",
      product: "Produkt",
      return: "Rendite",
      nameReplacements: "Standardnamen ersetzen",
      nameReplacementsTooltip:
        "Passen Sie die Produkt- und Benchmark-Namen in der Komponente an. Lassen Sie das Feld leer, um die vorhandenen Namen zu übernehmen.",
    },
    notify: {
      componentSaveSuccess: (ctx) =>
        `Ihre Komponente '${ctx.named("componentId")}' wurde erfolgreich aktualisiert.`,
    },
    overviewHeader: {
      backgroundImage: "Hintergrundbild",
      backgroundImageTooltip:
        "Bitte beachten Sie, dass das aktuell betrachtete Bild auch als Produktkartenbild auf der Homepage verwendet wird. Änderungen an diesem Bild wirken sich daher gleichzeitig auf die Darstellung des Produkts auf der Homepage aus.",
      hideProductName: "Produktname ausblenden",
      text: "Text",
      textInPrimary: "Text in Markenfarbe",
      textTooltip:
        "Bitte beachten Sie, dass der aktuell betrachtete Text auch als Produktkartentext auf der Homepage verwendet wird. Änderungen an diesem Text wirken sich daher gleichzeitig auf die Darstellung des Produkts auf der Homepage aus.",
      showDownloadLastFactsheetButton:
        'Schaltfläche "@:components.extras.downloadLastFactsheet.downloadLastFactsheet" anzeigen',
      showDownloadLastFactsheetButtonTooltip:
        'Damit die Schaltfläche für einen Benutzer sichtbar ist, sollte ein Dokument als "@:pages.products.documents.prompt.uploadFile.shouldConsiderLastFactsheet" im Abschnitt "Dokumente" markiert sein, und es sollte in der vom Benutzer gewählten Sprache verfügbar sein.',
      saveSuccess: "Kopfzeile wurde erfolgreich aktualisiert.",
      showFollowButton: "Schaltfläche zum Folgen anzeigen",
      title: "Übersichtskopf bearbeiten",
    },
    overviewStyle: {
      colorSchemePicker: "Farbschema-Auswahl",
      colorSchemeTooltip:
        "Dieses Farbschema wird derzeit auf Kreis- und Donutdiagramme angewendet. Wenn keine Farben angegeben werden, verwenden die Diagramme standardmäßig das allgemeine Farbschema der Plattform.",
      saveSuccess: "Der Stil wurde erfolgreich aktualisiert.",
      title: "Stil",
      titlesBold: {
        title: "Komponententitel fett",
      },
    },
    productDetails: {
      addDetail: "Detail hinzufügen",
      exampleIsin: "Z.B., ISIN",
      exampleLU: "Z.B., LU2220388479",
      key: "Schlüssel",
      noteDragAndDrop:
        "Hinweis: Durch Ziehen und Ablegen von Zeilen können Sie die Reihenfolge der Details ändern.",
      removeDetail: "Detail entfernen",
      showAgio: "Agio anzeigen",
      showAuM: "AuM anzeigen",
      showLastPrice: "Letzten Preis anzeigen",
      showIsin: "ISIN anzeigen",
      showTer: "TER anzeigen",
      value: "Wert",
    },
    relativePerformanceChart: {
      footnote: "Fussnote",
      placeholderFootnote:
        "Ein Text, der unterhalb des Diagramms erscheint. Z.B. 'Gebühren sind enthalten.'",
    },
    riskProfile: {
      level: "Höhe des Risikos",
    },
    shareClassesTable: {
      bloomberg: "Bloomberg",
      class: "Klasse",
      column: "Spalte",
      columnsToShow: "Anzuzeigende Spalten",
      showColumn: "Spalte anzeigen",
      defaultFootnote:
        "Perf. Lanc.: Die Renditen für Zeiträume seit Auflegung von mehr als einem Jahr werden annualisiert, bei weniger als einem Jahr werden sie nicht annualisiert.",
      footnote: "Fussnote",
      inceptionDate: "Auflage",
      isin: "ISIN",
      mgmtFee: "Mgmt. Fee",
      minInvestment: "Min. Anlage",
      perfFee: "Perf. Fee",
      ter: "TER",
      title: "Tabelle der Anteilsklassen bearbeiten",
    },
    statistics: {
      benchmark: "Benchmark",
      product: "Produkt",
      nameReplacements: "Standardnamen ersetzen",
      nameReplacementsTooltip:
        "Passen Sie die Produkt- und Benchmark-Namen in der Komponente an. Lassen Sie das Feld leer, um die vorhandenen Namen zu übernehmen. Verwenden Sie z.B. einen Begriff wie 'Produkt', um den Namen abzukürzen und Platz zu sparen.",
      fieldsToDisplay: "Anzuzeigende Felder",
      noteDragAndDrop:
        "Hinweis: Durch Ziehen und Ablegen von Zeilen können Sie die angezeigten Statistiken neu anordnen.",
      shownStatisticName: "Angezeigter Statistikname",
      showStatistic: "Statistik anzeigen",
      statisticId: "Statistik-ID",
    },
    statisticsWithPeriods: {
      benchmark: "Benchmark",
      product: "Produkt",
      nameReplacements: "Standardnamen ersetzen",
      nameReplacementsTooltip:
        "Passen Sie die Produkt- und Benchmark-Namen in der Komponente an. Lassen Sie das Feld leer, um die vorhandenen Namen zu übernehmen. Verwenden Sie z.B. einen Begriff wie 'Produkt', um den Namen abzukürzen und Platz zu sparen.",
      fieldsToDisplay: "Anzuzeigende Felder",
      noteDragAndDrop:
        "Hinweis: Durch Ziehen und Ablegen von Zeilen können Sie die angezeigten Statistiken neu anordnen.",
      periodsTitle: "Anzuzeigende Zeiträume",
      shownStatisticName: "Angezeigter Statistikname",
      showStatistic: "Statistik anzeigen",
      statisticId: "Statistik-ID",
      periods: {
        1: "1M",
        3: "3M",
        6: "6M",
        ytd: "YTD",
        12: "1J",
        36: "3J",
        60: "5J",
        84: "7J",
        120: "10J",
        max: "MAX",
      },
    },
    holdingsTable: {
      aggregateHoldings: "Positionen aggregieren",
      aggregateHoldingsTooltip:
        "Fasst den Wert und das Gewicht von Positionen zusammen, die denselben 'Holding-Name', 'Isin' und 'Währung' haben. Alle anderen Eigenschaften werden aus der Position mit dem höchsten Gewicht in der Gruppe übernommen. Sie können diese Gruppierung im Bereich 'Holding-Datenanpassungen' → 'Überschreiben' steuern, indem Sie eines dieser drei Felder ändern.",
      fieldsToDisplay: "Anzuzeigende Felder",
      lagRule: "Verzögerungsregel für Daten",
      lagRuleTooltip:
        "Wählen Sie, um wie viel die in dieser Komponente angezeigten Daten verzögert werden sollen. Eine Zwei-Monats-Ende-Verzögerung bedeutet zum Beispiel, dass die neuesten verfügbaren Daten vom Monatsende vor zwei Monaten angezeigt werden. Wenn heute der 15. Januar 2025 ist, werden die Daten bis zum 30. November 2024 angezeigt.",
      showHeader: "Kopfzeile anzeigen",
      showHoldingsCount:
        "„X von Y Positionen“ anzeigen, wenn nicht alle Positionen angezeigt werden",
      showTotal: "Summe anzeigen",
      numHoldings: {
        title: "Anzahl der anzuzeigenden Positionen",
        tooltip:
          "Wenn Sie dieses Feld leer lassen, werden alle verfügbaren Daten zu den Beständen des Produkts angezeigt.",
      },
      holdingsToIgnore: {
        title: "Zu ignorierende Holdings",
        holdingsMultiselect: {
          placeholder: "Zu ignorierende Holdings auswählen",
          selectLabel: "Enter drücken zum Auswählen",
          deselectLabel: "Enter drücken, um zu entfernen",
          selectedLabel: "Ausgewählt",
          limitText: (ctx) => `und ${ctx.named("count")} weitere`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Holdings ignorieren, deren Name enthält",
        placeholder: "z. B. Bargeld, Sonstiges",
      },
      propertyFilters: {
        property: "Eigenschaft",
        multiSelect: {
          placeholder: "Werte auswählen",
          selectLabel: "Enter drücken zum Auswählen",
          deselectLabel: "Enter drücken, um zu entfernen",
          selectedLabel: "Ausgewählt",
          limitText: (ctx) => `und ${ctx.named("count")} weitere`,
        },
      },
      lagRuleOptions: {
        noLag: "Keine Verzögerung (aktuellste Daten)",
        oneMonthEnd: "Monatsende des Vormonats",
        twoMonthEnd: "Monatsende vor zwei Monaten",
      },
      displayOrder: "Anzeigereihenfolge",
      sortOptions: {
        alphabeticallyAscending: "Holding-Name (A → Z)",
        alphabeticallyDescending: "Holding-Name (Z → A)",
        weightAscending: "Gewicht (niedrig → hoch)",
        weightDescending: "Gewicht (hoch → niedrig)",
      },
      customizeTable: "Tabelle anpassen",
      addColumn: "Spalte hinzufügen",
      columnWithIndex: (ctx) => `Spalte ${ctx.named("idx")}`,
    },
  },
  extras: {
    changeRoles: {
      changeRoles: "Rollen ändern",
      notify: {
        errorText: "Keine Rollen wurden aktualisiert. Grund: ",
        successText: "Benutzerrollen wurden aktualisiert",
      },
    },
    deleteGenericComponent: {
      delete: "Löschen",
      deleteAllComponents: "Alle Komponenten löschen",
      deleteOnlyThisComponent: "Nur diese Komponente löschen",
      Löschen: "Löschen von ...",
      deleteSuccess: "Löschung erfolgreich.",
      view: "Ansicht",
      shareClass: "Aktienklasse",
      textIsNotLinked:
        "Sie sind im Begriff, eine generische Komponente dauerhaft zu löschen. Diese Aktion kann nicht rückgängig gemacht werden. Bitte bestätigen Sie, dass Sie mit der Löschung fortfahren möchten.",
      textIsLinkedFirstPart:
        "Sie sind im Begriff, eine generische Komponente dauerhaft zu löschen. Diese Aktion kann nicht rückgängig gemacht werden.  Beachten Sie, dass diese Komponente mit der gleichen Komponente(n) im Folgenden verknüpft ist: ",
      textIsLinkedSecondPart:
        "Bitte bestätigen Sie, dass Sie mit dem Löschen fortfahren möchten, und entscheiden Sie, ob Sie nur die aktuelle Komponente löschen möchten, oder ob Sie diese Komponente und alle verknüpften Komponenten löschen möchten.",
      title: (ctx) => `Dauerhafte Löschung von ${ctx.named("componentId")}`,
    },
    deleteUser: {
      button: "Löschen",
      dialog: {
        confirm: "Benutzer löschen",
        text: "Sind Sie sicher, dass Sie diesen Benutzer dauerhaft löschen möchten?",
        title: "Benutzer löschen",
      },
      notify: {
        errorText: "Löschen des Benutzers fehlgeschlagen.",
        successText: "Benutzer wurde gelöscht.",
      },
    },
    downloadLastFactsheet: {
      downloadLastFactsheet: "Aktuelles Factsheet herunterladen",
      downloadingLastFactsheet: "Downloading...",
      needLogin: {
        text: "Um dieses Dokument herunterladen zu können, müssen Sie authentifiziert sein.",
        title: "Sie müssen authentifiziert sein",
      },
    },
    manualVerifyEmail: {
      forceVerification: "E-Mail-Verifizierung erzwingen",
      verified: "E-Mail verifiziert",
      notify: {
        errorText: "E-Mail-Verifizierung ist fehlgeschlagen.",
        successText: "Die E-Mail des Benutzers wurde manuell verifiziert.",
      },
    },
    riskProfile: {
      higherRisk: "Höheres Risiko",
      lowerRisk: "Niedrigeres Risiko",
    },
  },
  graphs: {
    logScale: "Logarithmische Skala",
    notEnoughData:
      "Nicht genügend Daten, um dieses Diagramm zu erstellen. Bitte wählen Sie einen längeren Zeitraum.",
    needMoreData:
      "Um diese Kennzahl zu berechnen, ist eine bestimmte Menge an Daten erforderlich. Vergrößern Sie den Zeitrahmen, um Zugang zu dieser Kennzahl zu erhalten.",
  },
  holdingDataAdjustments: {
    categorise: {
      addCategory: {
        button: "Kategorie hinzufügen",
        prompt: {
          category: "Kategorie",
          product: "Produkt",
          property: "Eigenschaft",
          title: "Kategorie hinzufügen",
          value: "Wert",
          valueAlreadyHasCategory: "Dieser Wert ist bereits einer Kategorie zugeordnet.",
        },
      },
      exportCategories: {
        button: "Kategorien als CSV exportieren",
        buttonTooltip: "Laden Sie die angezeigten Kategorie-Zuordnungen als CSV-Datei herunter.",
      },
      importCategories: {
        button: "Kategorien aus CSV importieren",
        buttonTooltip:
          "Importieren Sie eine CSV-Datei, um Kategoriezuteilungen in großen Mengen zu aktualisieren.",
        importPrompt: {
          buttonCancel: "Abbrechen",
          buttonImport: "Importieren",
          text: "Laden Sie eine korrekt formatierte CSV-Datei hoch, um Ihre Zuordnungen zu aktualisieren. Wir empfehlen, zuerst die aktuelle Zuordnung zu exportieren, um die Spaltenstruktur zu überprüfen. Sie können eine Teildatei hochladen, die nur neue oder geänderte Zeilen enthält; nicht erwähnte Daten werden nicht geändert.",
          title: "Kategorien per CSV importieren",
        },
        importErrorsPrompt: {
          close: "Schließen",
          selectErrorType: "Fehlertyp auswählen:",
          title: "CSV-Validierungsfehler",
          columns: {
            firstRow: "Erste Zeile",
            productName: "Produktname",
            property: "Eigenschaft",
            rowIndex: "Zeilenindex",
            value: "Wert",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Die folgenden erforderlichen Spalten fehlen:",
            notExpectedColumns: "Die folgenden unerwarteten Spalten wurden gefunden:",
            title: "Spaltenabweichung",
            text: 'Stellen Sie sicher, dass die CSV-Kopfzeile die folgenden Spalten enthält: "product_name, property, value, category".',
          },
          nonExistentProductName: {
            title: "Unbekannter Produktname",
            text: "Stellen Sie sicher, dass alle Produktnamen existieren.",
          },
          invalidPropertyForProductName: {
            title: "Ungültige Eigenschaft für Produkt",
            text: 'Einige Eigenschaften sind für die ausgewählten Produkte nicht verfügbar. Entfernen Sie diese oder überprüfen Sie sie im Tab "Holding Data" unter dem Abschnitt "Produkte" im Admin-Panel.',
          },
          duplicatedCategory: {
            title: "Doppelte Kategorie für einen Wert",
            text: "Entfernen Sie doppelte Kategorieeinträge für denselben Wert.",
          },
          papaparseMissingQuotes: {
            title: "Nicht geschlossene Anführungszeichen",
            text: "Die CSV-Analyse ist fehlgeschlagen, weil eine Zeichenkette in Anführungszeichen nicht korrekt geschlossen wurde. Bitte überprüfen Sie Ihre Daten auf fehlende abschließende Anführungszeichen.",
          },
          papaparseUndetectableDelimiter: {
            title: "Nicht erkennbarer Trenner",
            text: "Die CSV-Analyse ist fehlgeschlagen. Es konnte kein gängiger Trenner erkannt werden. Bitte stellen Sie sicher, dass Ihre Datei durchgängig nur einen Trenner verwendet – üblicherweise ein Komma oder ein Semikolon.",
          },
          papaparseTooFewFields: {
            title: "Zu wenige Felder",
            text: "Die CSV-Analyse ist fehlgeschlagen. Einige Zeilen enthalten weniger als die erforderlichen 4 Felder. Bitte überprüfen Sie den Aufbau Ihrer Datei.",
          },
          papaparseTooManyFields: {
            title: "Zu viele Felder",
            text: "Die CSV-Analyse ist fehlgeschlagen. Einige Zeilen enthalten mehr als die erwarteten 4 Felder. Bitte überprüfen Sie den Aufbau Ihrer Datei.",
          },
        },
      },
      saveCategories: {
        button: "Alle Änderungen speichern",
        saveSuccess: "Die Kategorien der Bestandsdaten wurden erfolgreich gespeichert.",
        updateWarningPrompt: {
          title: "Auswirkungen des Speicherns von Änderungen",
          text: "Sie sind dabei, die Kategorisierung zu speichern, nachdem Sie eine oder mehrere Zeilen durch Entfernen oder Aktualisieren ihrer Kategorie geändert haben. Falls die betroffenen Kategorien gespeicherte Übersetzungen haben, können diese gelöscht werden – es sei denn, die Kategorie existiert weiterhin für dasselbe Produkt über einen anderen Wert. Zusätzlich, falls diese Kategorien verwendet wurden, um Bestandskomponenten zu überschreiben, werden diese Überschreibungen ebenfalls entfernt – es sei denn, die Kategorie existiert weiterhin für dasselbe Produkt über einen anderen Wert.",
        },
      },
    },
    translate: {
      exportTranslations: {
        button: "Übersetzungen als CSV exportieren",
        buttonTooltip: "Laden Sie die angezeigten Übersetzungs-Zuordnungen als CSV-Datei herunter.",
      },
      importTranslations: {
        button: "Übersetzungen aus CSV importieren",
        buttonTooltip: "Eine CSV-Datei importieren, um Übersetzungen massenhaft zu aktualisieren.",
        importPrompt: {
          buttonCancel: "Abbrechen",
          buttonImport: "Importieren",
          text: "Laden Sie eine korrekt formatierte CSV-Datei hoch, um Ihre Zuordnungen zu aktualisieren. Wir empfehlen, zuerst die aktuelle Zuordnung zu exportieren, um die Spaltenstruktur zu überprüfen. Sie können eine Teildatei hochladen, die nur neue oder geänderte Zeilen enthält; nicht erwähnte Daten werden nicht geändert.",
          title: "Übersetzungen über CSV importieren",
        },
        importErrorsPrompt: {
          close: "Schließen",
          selectErrorType: "Fehlertyp auswählen:",
          title: "CSV-Validierungsfehler",
          columns: {
            firstRow: "Erste Zeile",
            language: "Sprache",
            productName: "Produktname",
            property: "Eigenschaft",
            rowIndex: "Zeilenindex",
            category: "Kategorie",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Folgende erforderliche Spalten fehlen:",
            notExpectedColumns: "Folgende unerwartete Spalten wurden gefunden:",
            title: "Spalten stimmen nicht überein",
            text: (ctx) =>
              `Stellen Sie sicher, dass die Kopfzeile der CSV die folgenden Spalten enthält: ${ctx.named("expectedColumns").join(", ")}.`,
          },
          nonExistentProductName: {
            title: "Unbekannter Produktname",
            text: "Stellen Sie sicher, dass alle Produktnamen vorhanden sind.",
          },
          invalidPropertyForProductName: {
            title: "Ungültige Eigenschaft für Produkt",
            text: 'Einige Eigenschaften sind für die ausgewählten Produkte nicht verfügbar. Entfernen Sie sie oder überprüfen Sie sie im Reiter "Holding Data" unter "Produkte" im Admin-Bereich.',
          },
          duplicatedTranslations: {
            title: "Doppelte Übersetzungen für einen Wert",
            text: "Entfernen Sie doppelte Übersetzungseinträge für denselben Wert.",
          },
          invalidCategoryForProductNameAndProperty: {
            title: "Ungültige Kategorie für Produkteigenschaft",
            text: "Die ausgewählte Kategorie existiert für diese Produkteigenschaft nicht. Bitte prüfen Sie die zulässigen Kategorien.",
          },
          invalidTranslationLangForProductName: {
            title: "Sprache für Produkt nicht verfügbar",
            text: "Sie können keine Übersetzung in einer Sprache angeben, die für das Produkt nicht aktiviert ist. Exportieren Sie bitte die CSV und prüfen Sie eine Zeile des Produkts auf verfügbare Sprachen.",
          },
          papaparseMissingQuotes: {
            title: "Nicht geschlossene Anführungszeichen",
            text: "Die CSV-Analyse ist fehlgeschlagen, weil eine Zeichenkette in Anführungszeichen nicht korrekt geschlossen wurde. Bitte überprüfen Sie Ihre Daten auf fehlende abschließende Anführungszeichen.",
          },
          papaparseUndetectableDelimiter: {
            title: "Nicht erkennbarer Trenner",
            text: "Die CSV-Analyse ist fehlgeschlagen. Es konnte kein gängiger Trenner erkannt werden. Bitte stellen Sie sicher, dass Ihre Datei durchgängig nur einen Trenner verwendet – üblicherweise ein Komma oder ein Semikolon.",
          },
          papaparseTooFewFields: {
            title: "Zu wenige Felder",
            text: "Die CSV-Analyse ist fehlgeschlagen. Jede Zeile sollte die gleiche Anzahl an Spalten wie die Kopfzeile enthalten. Derzeit haben einige Zeilen weniger Spalten als erwartet. Bitte überprüfen Sie die Struktur Ihrer Datei.",
          },
          papaparseTooManyFields: {
            title: "Zu viele Felder",
            text: "Die CSV-Analyse ist fehlgeschlagen. Jede Zeile sollte die gleiche Anzahl an Spalten wie die Kopfzeile enthalten. Derzeit haben einige Zeilen mehr Spalten als erwartet. Bitte überprüfen Sie die Struktur Ihrer Datei.",
          },
        },
      },
      saveTranslations: {
        button: "Alle Änderungen speichern",
        saveSuccess: "Übersetzungen der Holding-Daten erfolgreich gespeichert.",
      },
    },
    override: {
      exportOverrides: {
        button: "Überschreibungen als CSV exportieren",
        buttonTooltip:
          "Laden Sie die angezeigten Überschreibungs-Zuordnungen als CSV-Datei herunter.",
      },
      importOverrides: {
        button: "Überschreibungen aus CSV importieren",
        buttonTooltip:
          "Importieren Sie eine CSV-Datei, um Überschreibungen gesammelt zu aktualisieren.",
        importPrompt: {
          buttonCancel: "Abbrechen",
          buttonImport: "Importieren",
          text: "Laden Sie eine korrekt formatierte CSV-Datei hoch, um Ihre Zuordnungen zu aktualisieren. Wir empfehlen, zuerst die aktuelle Zuordnung zu exportieren, um die Spaltenstruktur zu überprüfen. Sie können eine Teildatei hochladen, die nur neue oder geänderte Zeilen enthält; nicht erwähnte Daten werden nicht geändert.",
          title: "Überschreibungen per CSV importieren",
        },
        importErrorsPrompt: {
          close: "Schließen",
          selectErrorType: "Fehlertyp auswählen:",
          title: "CSV-Validierungsfehler",
          columns: {
            category: "Kategorie",
            currency: "Währung",
            firstRow: "Erste Zeile",
            holdingName: "Holding-Name",
            isin: "ISIN",
            productName: "Produktname",
            property: "Eigenschaft",
            rowIndex: "Zeilenindex",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Folgende erforderliche Spalten fehlen:",
            notExpectedColumns: "Folgende unerwartete Spalten wurden gefunden:",
            title: "Spalten stimmen nicht überein",
            text: (ctx) =>
              `Stellen Sie sicher, dass der CSV-Header die folgenden Spalten enthält: ${ctx.named("expectedColumns").join(", ")}.`,
          },
          unknownProductName: {
            title: "Unbekannter Produktname",
            text: "Einige Produktnamen in Ihrer Datei stimmen mit keinem existierenden Produkt überein. Bitte prüfen Sie auf Tippfehler oder ungültige Namen.",
          },
          invalidPropertyForProductName: {
            title: "Ungültige Eigenschaft für Produkt",
            text: "Einige Eigenschaften sind für die ausgewählten Produkte nicht verfügbar. Entfernen oder überprüfen Sie diese im Tab 'Holding-Daten' im Bereich 'Produkte' im Admin-Panel.",
          },
          unknownOverrideCategory: {
            title: "Unbekannte Überschreibungskategorie",
            text: "Einige Überschreibungswerte beziehen sich auf nicht existierende Kategorien für das angegebene Produkt und die Eigenschaft. Bitte überprüfen Sie vor dem Import die verfügbaren Kategorien.",
          },
          invalidConstituent: {
            title: "Ungültiger Konstituentenschlüssel",
            text: "Einige Zeilen beziehen sich auf Konstituenten (Produktname, Holding-Name, ISIN, Währung), die nicht existieren. Bitte entfernen oder korrigieren Sie diese Einträge.",
          },
          duplicateConstituent: {
            title: "Doppelte Überschreibungen",
            text: "Mehrere Überschreibungen wurden für denselben Konstituenten gefunden (Produktname, Holding-Name, ISIN, Währung). Bitte behalten Sie nur einen Eintrag pro Konstituenten bei.",
          },
          papaparseMissingQuotes: {
            title: "Nicht geschlossene Anführungszeichen",
            text: "Die CSV-Analyse ist fehlgeschlagen, weil eine Zeichenkette in Anführungszeichen nicht korrekt geschlossen wurde. Bitte überprüfen Sie Ihre Daten auf fehlende abschließende Anführungszeichen.",
          },
          papaparseUndetectableDelimiter: {
            title: "Nicht erkennbarer Trenner",
            text: "Die CSV-Analyse ist fehlgeschlagen. Es konnte kein gängiger Trenner erkannt werden. Bitte stellen Sie sicher, dass Ihre Datei durchgängig nur einen Trenner verwendet – üblicherweise ein Komma oder ein Semikolon.",
          },
          papaparseTooFewFields: {
            title: "Zu wenige Felder",
            text: "Die CSV-Analyse ist fehlgeschlagen. Jede Zeile sollte die gleiche Anzahl an Spalten wie die Kopfzeile enthalten. Derzeit haben einige Zeilen weniger Spalten als erwartet. Bitte überprüfen Sie die Struktur Ihrer Datei.",
          },
          papaparseTooManyFields: {
            title: "Zu viele Felder",
            text: "Die CSV-Analyse ist fehlgeschlagen. Jede Zeile sollte die gleiche Anzahl an Spalten wie die Kopfzeile enthalten. Derzeit haben einige Zeilen mehr Spalten als erwartet. Bitte überprüfen Sie die Struktur Ihrer Datei.",
          },
        },
      },
      saveOverrides: {
        button: "Alle Änderungen speichern",
        saveSuccess: "Holding-Daten-Überschreibungen erfolgreich gespeichert.",
      },
    },
  },
  holdingData: {
    others: "Andere",
  },
  images: {
    uploadImage: {
      darkening: "Verdunkelung",
      file: "Datei",
      noFile: "Keine Datei",
      noImage: "Kein Bild",
      promptTitle: "Neues Bild hochladen",
      selectFile: "Datei auswählen",
      selectNewImage: "Neues Bild auswählen",
      submit: "Einreichen",
      submitting: "Wird eingereicht...",
      errorTitleTooLarge: "Bild zu groß",
      errorMessageTooLarge:
        "Das Bild ist zu groß. Bitte wählen Sie ein anderes Bild mit einer Größe von weniger als 30 MB.",
      warningTitleVeryLarge: "Bild sehr groß",
      warningMessageVeryLarge:
        "Das Bild ist sehr groß. Dadurch werden die Seiten, die dieses Bild anzeigen, langsamer geladen. Für eine optimale Leistung wird empfohlen, Bilder mit einer Größe von weniger als 10 MB zu verwenden.",
    },
  },
  linkPrompt: {
    componentLinkedTo: "Diese Komponente ist verknüpft mit:",
    currentView: "Aktuelle Ansicht",
    currentShareClass: "Aktuelle Aktienklasse",
    linkThroughViewsTooltip:
      'Wenn Sie diese Funktion aktivieren, wird eine synchronisierte Verbindung zwischen Komponenten auf mehreren Ansichten hergestellt. Durch die Verknüpfung der Ansichten "Factsheet" und "Übersicht" wird beispielsweise sichergestellt, dass alle Änderungen an einer gemeinsamen Komponente auf beiden Ansichten gleichzeitig aktualisiert werden. Wichtig: Der Inhalt der verknüpften Komponente wird von der Ansicht der Quelle, die Sie gerade bearbeiten, dupliziert. Wenn Sie die Verknüpfung initiieren, während Sie die Komponente "Beschreibung" auf der Ansicht "Factsheet" bearbeiten, wird die Komponente "Beschreibung" von "Factsheet" auf die Ansicht "Übersicht" kopiert und überschreibt somit die Komponente "Beschreibung" von "Übersicht".',
    linkThroughShareClassesTooltip:
      'Wenn Sie diese Funktion aktivieren, wird eine synchronisierte Verbindung zwischen Komponenten über mehrere Freigabeklassen hinweg hergestellt. Durch die Verknüpfung der "Produkt Aktienklassen A" und der "Produkt Aktienklassen B" wird beispielsweise sichergestellt, dass alle Änderungen an einer freigegebenen Komponente in beiden Freigabeklassen gleichzeitig aktualisiert werden. Wichtig: Der Inhalt der verknüpften Komponente wird von der Ansicht der Quelle dupliziert, die Sie gerade bearbeiten. Wenn Sie die Verknüpfung initiieren, während Sie die Komponente "Beschreibung" auf der Ansicht "Produkt Aktienklassen A" bearbeiten, wird die Komponente "Beschreibung" in "Produkt Aktienklassen A" in "Produkt Aktienklassen B" kopiert und überschreibt somit die Komponente "Beschreibung" in "Produkt Aktienklassen B".',
    linkThroughShareClassesForbiddenCrossProductTooltip:
      "Diese Komponente zeigt Daten für alle Aktienklassen an und ist daher immer über alle Aktienklassen des Produkts hinweg verknüpft. Einzelne Aktienklassen können aus diesem Grund nicht entknüpft werden; nur Verknüpfungen zu anderen Ansichten können entfernt werden.",
    linkedWithViews: "Verknüpft mit den folgenden Ansichten",
    linkedWithShareClasses: "Verknüpft mit den folgenden Aktienklassen",
    view: "Ansicht",
    shareClass: "Aktienklasse",
    title: (ctx) => `Verknüpfung von ${ctx.named("componentId")} bearbeiten`,
    unlink: "Entbinden",
    unlinking: "Entbinden...",
    unsavedChangesAlert:
      "Sie haben ungespeicherte Änderungen. Wenn Sie die Seite verlassen, ohne zu speichern, gehen sie verloren.",
    confirmSaveDialog: {
      computingNewLinks: "Berechnung neuer Links...",
      onceLinked:
        "Einmal verknüpft, werden alle anderen verknüpften Komponenten auf die gleiche Weise aktualisiert, wenn eine Änderung an einer Komponente an einem dieser Orte (einschließlich des aktuellen) vorgenommen wird. Bitte bestätigen Sie, dass Sie mit dem Speichern fortfahren möchten.",
      overwrittenExistingComponent: "Überschreiben einer Komponente mit der gleichen ID",
      overwrittenExistingComponentTooltip: (ctx) =>
        `Warnung: Es gibt bereits eine Komponente mit der ID '${ctx.named(
          "componentId"
        )}' an dieser Stelle, so dass sie von dieser Komponente überschrieben wird, wenn Sie sie verlinken.`,
      title: "Bestätigen Sie die Speicherung der neuen Links",
      youAreAboutToLink:
        "Sie sind dabei, die aktuelle Komponente mit den Komponenten an den folgenden Stellen zu verknüpfen:",
    },
    overviewStyle: {
      title: "Links im Stil der Übersicht bearbeiten",
      saveSuccess: "Die Aktualisierung der Stil-Links war erfolgreich.",
    },
    reportFooter: {
      title: "Links in der Fusszeile des Berichts bearbeiten",
      saveSuccess: "Die Aktualisierung der Fusszeilenlinks war erfolgreich.",
    },
    reportHeader: {
      title: "Links in der Kopfzeile des Berichts bearbeiten",
      saveSuccess: "Die Aktualisierung der Kopfzeilenlinks war erfolgreich.",
    },
    reportStyle: {
      title: "Links im Stil des Berichts bearbeiten",
      saveSuccess: "Die Aktualisierung der Stil-Links war erfolgreich.",
    },
    notify: {
      linkSaveSuccess: (ctx) =>
        `Die Verknüpfungsaktualisierung von '${ctx.named("componentId")}' war erfolgreich.`,
    },
    multiselect: {
      placeholderShareClasses: "Zu verlinkende Assetklassen auswählen",
      placeholderViews: "Zu verlinkende Ansichten auswählen",
      selectLabel: "Zum Auswählen die Eingabetaste drücken",
      deselectLabel: "Zum Entfernen die Eingabetaste drücken",
      selectedLabel: "Ausgewählt",
    },
    overviewHeader: {
      title: "Verknüpfung des Übersichtskopfes bearbeiten",
      saveSuccess: "Die Aktualisierung der Verknüpfung des Kopfes war erfolgreich.",
    },
  },
  pricesManagement: {
    addData: "Daten hinzufügen",
    autoDataUpdate: "Ihre Daten werden automatisch aktualisiert.",
    date: "Datum",
    datePlaceholder: "JJJJ-MM-TT",
    dateValidationError: "Sie können kein Datum hinzufügen, das bereits einen Wert hat.",
    exportCsvButton: "Als CSV exportieren",
    importCsvButton: "Aus einer CSV importieren",
    launchPriceUpdateButton: "Aktualisierung starten",
    launchPriceUpdateTooltip:
      "Durch Klicken auf diese Schaltfläche erzwingen Sie eine Aktualisierung, indem die neuesten Daten von der Quelle abgerufen werden, die normalerweise für die automatische tägliche Aktualisierung verwendet wird (falls diese Daten automatisch aktualisiert werden). Es kann einige Minuten dauern, bis die Daten abgerufen und aktualisiert sind.",
    launchPriceUpdateRunningTooltip: "Die Preise werden derzeit abgerufen.",
    loadingData: "Daten werden geladen...",
    price: "Preis",
    priceAdj: "Preis (angepasst)",
    priceAdjTooltip:
      "Im Allgemeinen bedeuten bereinigte Preise Preise, die um Dividenden, Splits und andere Ereignisse bereinigt sind. Wenn keine Angaben gemacht werden, wird davon ausgegangen, dass es sich um den gleichen Preis handelt.",
    priceAdjTooltipTable:
      "Im Allgemeinen bedeuten bereinigte Preise Preise, die um Dividenden, Splits und andere Ereignisse bereinigt sind.",
    refreshButton: "Aktualisieren",
    removeData: "Daten entfernen",
    benchmarks: {
      noBenchmark: "Für dieses Produkt ist kein Benchmark verfügbar.",
    },
    dialog: {
      removeData: {
        title: "Datenpunkt entfernen",
        text: "Sie werden einen Datenpunkt vollständig entfernen. Sind Sie sicher?",
      },
    },
    importCsvText: {
      para1:
        "Die Eingabedatei sollte im CSV-Format vorliegen, mit zwei oder drei Spalten und einer Kopfzeile.",
      para2:
        "Die erste Spalte sollte aus Datumsangaben bestehen, die zweite Spalte aus Zahlen (der Preis zum entsprechenden Datum). Eine dritte Spalte ist fakultativ und sollte, wenn sie angegeben wird, aus Zahlen bestehen, die dem angepassten Preis entsprechen; wenn sie nicht angegeben wird, wird angenommen, dass die angepassten Preise mit den Preisen übereinstimmen.",
      para3:
        "Bitte stellen Sie sicher, dass Ihre CSV-Datei gültig ist, um Probleme beim Lesen und Parsen der Daten zu vermeiden.",
    },
    notify: {
      dateUsedMultipleTimeError:
        "Einem Datum sind mehrere Preise zugeordnet. Sie müssen sicherstellen, dass jedem Datum ein eindeutiger Preis zugewiesen wird.",
      launchSuccessText:
        "Die Preisaktualisierung wurde erfolgreich gestartet. Bitte aktualisieren Sie in einigen Minuten, um die Ergebnisse zu sehen.",
      launchErrorText: "Fehler beim Starten der Preisaktualisierung, bitte kontaktieren Sie uns.",
      nanFound:
        "Es wurden einige leere Werte gefunden. Bitte stellen Sie sicher, dass alle Zeilen und Spalten einen Wert enthalten.",
      numberFormatError:
        'Mindestens eine der Zahlen hat ein unerkanntes Format. Idealerweise sollten Sie keine Trennzeichen für Tausender verwenden und einen Punkt als Dezimaltrennzeichen einsetzen, da dies das erwartete Format ist. Zum Beispiel "102,12", "1380,25", "18,952", ...',
      saveErrorText: "Fehler beim Aktualisieren der Preise, bitte kontaktieren Sie uns.",
      saveSuccessText: "Die Preise wurden erfolgreich aktualisiert.",
    },
    prompt: {
      addPrice: "Preis hinzufügen",
      importCsv: "Daten aus CSV importieren",
    },
  },
  tables: {
    metricsTable: {
      na: "N/V",
      name: "Name",
      showLess: "Weniger anzeigen",
      showMore: "Mehr anzeigen",
    },
    monthlyReturnsTable: {
      benchmark: "Benchmark",
      return: "Rendite",
    },
    performanceTable: {
      computedFromTo: (ctx) =>
        `Performance berechnet von ${ctx.named("firstDate")} bis ${ctx.named("lastDate")}.`,
      notAvailableData:
        "Daten nicht verfügbar, entweder weil nicht genügend Tage zur Berechnung vorhanden sind, die Daten nicht aussagekräftig sind (z.B. negative Sharpe-Ratio) oder der Benchmark im ausgewählten Zeitraum nicht immer verfügbar ist",
    },
    holdingsTable: {
      noDataYet: "Diese Komponente enthält noch keine Daten.",
      holdingFields: {
        currency: "Währung",
        holdingName: "Name",
        isin: "ISIN",
        value: "Wert",
        weight: "Gewicht",
      },
      totalOfPortfolio: "Gesamtportfolio",
      holdingsCountSummary: (ctx) => `${ctx.named("shown")} von ${ctx.named("total")} Positionen`,
    },
    liquidityAnalysisTable: {
      noDataYet: "Diese Komponente enthält noch keine Daten.",
      description: "Beschreibung",
      isin: "ISIN",
      currency: "Währung",
      aumInLocalCurrency: (ctx) => `AUM (${ctx.named("currency")})`,
      weight: "Gewicht",
      lessThanOneDay: "0-1 Tag",
      twoToSevenDays: "2-7 Tage",
      eightToThirtyDays: "8-30 Tage",
      thirtyOneToNinetyDays: "31-90 Tage",
      ninetyOneToOneHundredEightyDays: "91-180 Tage",
      oneHundredEightyOneToThreeHundredSixtyFiveDays: "181-365 Tage",
      moreThanThreeHundredSixtyFiveDays: ">365 Tage",
      totalOfPortfolio: "Gesamt des Portfolios",
    },
  },
  thirdParty: {
    vuePhoneNumberInput: {
      countrySelectorLabel: "Länderauswahl",
      countrySelectorError: "Wählen Sie ein Land",
      phoneNumberLabel: "Telefonnummer",
      example: "Beispiel :",
    },
  },
  videos: {
    uploadVideo: {
      file: "Datei",
      noFile: "Keine Datei",
      noVideo: "Kein Video",
      selectFile: "Datei auswählen",
      selectNewVideo: "Neues Video auswählen",
      errorTitleTooLarge: "Video zu groß",
      errorMessageTooLarge:
        "Das Video ist zu groß. Bitte wählen Sie ein anderes Video mit einer Größe von weniger als 30 MB.",
      warningTitleVeryLarge: "Video sehr groß",
      warningMessageVeryLarge:
        "Das Video ist sehr groß. Dadurch werden die Seiten, die dieses Video anzeigen, langsamer geladen. Für eine optimale Leistung wird empfohlen, Videos mit einer Größe von weniger als 10 MB zu verwenden.",
    },
  },
};
